import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const serviceProviderTypeList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/service-provider-type/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};

export const serviceProviderTypeAdd = (params) => {
  return _baseClient.post('/service-provider-type/save', { body: params }).then((response) => {
    return response;
  });
};

export const serviceProviderTypeDelete = (params) => {
  return _baseClient.get('/service-provider-type/delete', params);
};

export const serviceProviderTypeDetail = (params) => {
  return _baseClient.get('/service-provider-type/get', params);
};

export const serviceProviderTypeUpdateStatus = (params) => {
  return _baseClient.get('/service-provider-type/update-status', params);
};
